export const dialogNames = {
  INSERT_IMAGE_DIALOG: 'openInsertImageDialog',
  INSERT_DOCUMENT_DIALOG: 'openInsertDocumentDialog',
  INSERT_EMAIL_MACROS_DIALOG: 'openInsertEmailMacrosDialog',
  INSERT_ANCHOR_DIALOG: 'openInsertAnchorDialog',
  INSERT_LINK_TO_ANCHOR_DIALOG: 'openInsertLinkToAnchorDialog',
  INSERT_LINK_DIALOG: 'openInsertLinkDialog',
  INSERT_SLIDE_SHOW_LINKS: 'openInsertSlideShowLinkDialog'
};

export const urlTemplates = {
  baseDetailsUrlTemplate: '/event-{0}',
  baseRegistrationUrlTemplate: '/event-{0}/Registration'
};

export const eventRegExp = /^\/event-(\d+)/;
export const registrationFormTestRegExp = /^\/event-\d+\/Registration\/?$/;

export const endpoints = {
  macrosEndpoint: '/Sys/Admin/EmailBlast/GetEmailBlastMacros',
  eventsEndpoint: '/Sys/Admin/Events/GetEvents',
  pagesStructureEndpoint: '/Sys/Editor/GetInsertLinkDialogSiteStructure'
};

export const linkStyleIframeSrc = '/Sys/Editor/ReactDropdownBody';